export const firebasePublicFilesChildName = 'public_files';
export const firebasePrivateFilesChildName = 'private_files';
export const firebaseLessonsChildName = 'lessons';
export const firebaseRoomsName = 'rooms';
export const firebaseActiveLessonChildName = 'activeLesson';
export const firebaseQuestionsName = 'questions';
export const firebaseQuestionCodeChildName = 'code';
